//Custom hook for when user try to access the change password page without following the workflow of the app
//then we need  to prevent the user to access the change password page.
//Finding the token from Url and checking the token with refreshtoken stored in the localstorage if its correct then providing the access
//if there is no refreshTokenFromQuery in the url it means user is not redirected form email, so its not allowed;
//If there is no token it means user is not logged In;

import { useEffect } from 'react'
import { useNavigation } from '@pankod/refine-core'

function useVerifyUserLogged() {
  const { push } = useNavigation()

  useEffect(() => {
    async function verifyUserLogged() {
      const token = await localStorage.getItem('nhostRefreshToken')
      const currentUrl = window.location.href
      const queryParameters = new URLSearchParams(currentUrl.split('?')[1])
      const refreshTokenFromQuery = queryParameters.get('refreshToken')
      if (!token) {
        push('/login')
      } else {
        if (!refreshTokenFromQuery || token !== refreshTokenFromQuery) {
          push('/')
        }
      }
    }
    verifyUserLogged()
  }, [])
}

export default useVerifyUserLogged
